import { useEffect } from 'react';

const useScript = url => {
    url = `<script src = ${url} type="text/javascript" async="true"></script>`
    var ifr = document.createElement("iframe");
  useEffect(() => {
    ifr.setAttribute("frameborder", "0");
    ifr.setAttribute("scrolling", "no");
    ifr.setAttribute("style", `width: 100%; height:`);
    ifr.setAttribute("id", "iframeResult");
    ifr.setAttribute("name", "iframeResult");
    document.getElementById("iframewrapper").innerHTML = "";
    document.getElementById("iframewrapper").appendChild(ifr);
    let ifrw = (ifr.contentWindow) ? ifr.contentWindow : (ifr.contentDocument.document) ? ifr.contentDocument.document : ifr.contentDocument;
    ifrw.document.open();
    ifrw.document.write("<!DOCTYPE html>")
    ifrw.document.write(url); 
    ifrw.document.close();
    //ifr.setAttribute("onload",'(function(o){o.style.height=o.contentDocument.body.getElementsByTagName("iframe")[0].height;}(this));')
    const targetNode = document.getElementById('iframeResult').contentDocument;

// Options for the observer (which mutations to observe)
    const config = { attributes: true, childList: true, subtree: true };

// Callback function to execute when mutations are observed
    const callback = function(mutationList, observer) {
    // Use traditional 'for loops' for IE 11
    for (const mutation of mutationList) {
        
        if (mutation.type === 'childList') {
            //console.log('A child node has been added or removed.');
        }
        else if (mutation.type === 'attributes') {  
            console.log(`The ${mutation.attributeName} attribute was modified.`);
            if(mutation.attributeName == "height" || mutation.attributeName == "width")
            {
              let innerHeight = mutation.target.height
              //console.log(innerHeight)
              ifr.setAttribute("style", `width: 100%; height: ${innerHeight}`);
            }
        }
    }
};

// Create an observer instance linked to the callback function
const observer = new MutationObserver(callback);

// Start observing the target node for configured mutations
observer.observe(targetNode, config);
    return () => {
      //document.head.removeChild(script);
    }
  }, [url]);
};

export default useScript;